module.exports = __webpack_public_path__ + "img/qr_code.60f3db50.png";